import { Rect } from '../../../platform/geom/Rect';
import { TextRuler } from '../../canvas/visualization/TextRuler';
import { JiraSprintDateTextSettings } from './fields/JiraSprintDateField';
import { JiraSprintNameTextSettings } from './fields/JiraSprintNameField';
import { JiraSprint } from './JiraSprint';

const formatDate = (date: string) => !!date ? new Date(date).toLocaleDateString() : 'Not Set';

export const JiraSprintLayout = (object: JiraSprint) => {
    const source = new Rect(0, 0, object.width, 0);

    const inner = source.set({
        left: 15,
        right: source.right - 15,
        top: 15,
    });

    const nameHeight = TextRuler.measureHeight(
        object.record?.name ?? '',
        JiraSprintNameTextSettings,
        inner.width,
    );

    // Sprint name at top (30px height)
    const name = inner.set({
        height: nameHeight,
    });

    const dateRow = inner.set({ top: name.bottom + 10 });

    const fromDateSize = TextRuler.measureSize(formatDate(object.record?.startDate ?? ''), JiraSprintDateTextSettings);
    const fromDate = dateRow.set({
        width: fromDateSize.w,
        height: fromDateSize.h,
    });

    const toDateSize = TextRuler.measureSize(formatDate(object.record?.endDate ?? ''), JiraSprintDateTextSettings);
    const toDate = dateRow.set({
        left: fromDate.right + 10,
        width: toDateSize.w,
        height: toDateSize.h,
    });

    // Goal section (stretches to fill remaining space)
    const dateBottom = fromDate.bottom;
    const goal = inner.set({
        top: dateBottom + 10,
        height: Math.max(60, object.height - dateBottom - 25),
    });

    // Calculate total height needed
    const totalHeight = goal.bottom + 15;
    const base = source.set({ height: totalHeight });

    return {
        base,
        name,
        fromDate,
        toDate,
        goal,
    };
};

export type JiraSprintLayout = ReturnType<typeof JiraSprintLayout>;
